module.exports = __webpack_public_path__ + "5f572cd3f87b7166f548870a7afad1e7.svg";